import React from 'react';

interface SchemaReviewProps {
  score: number;
  gender: string;
  age?: number;
}

export function SchemaReview({ score, gender, age }: SchemaReviewProps) {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Review',
    itemReviewed: {
      '@type': 'Thing',
      name: `${gender} Attractiveness Analysis`
    },
    reviewRating: {
      '@type': 'Rating',
      ratingValue: score,
      bestRating: 10,
      worstRating: 1
    },
    author: {
      '@type': 'Organization',
      name: 'AI Attractiveness Test'
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schemaData)
      }}
    />
  );
}